export default __webpack_public_path__ + "static/media/malaysia-telecom-building.1a423bc2.jpg";